import gql from 'graphql-tag'

export default gql`
  query HelloSignQuery {
    helloSign {
      clientId
      testMode
    }
  }
`
